module.exports = __webpack_public_path__ + "static/media/warning.cf6217bc.svg";